<div class="container-fluid">
  <!-------profile with button design--------->
  <div class="row section1">
    <div class="col-12 col-md-7 col-lg-7 col-xl-7">
      <div class="home-details">
        @if (parameters.length) {
          <h5 class="home-title">Reviews by {{parameters[0].user.fullName}}</h5>
        }
        @if (parameters.length == 0) {
          <h5 class="home-title">No Reviews</h5>
        }
        <p class="home-subtitle">List of all Reviews</p>
      </div>
    </div>
    <div class="col-12 col-md-8 col-lg-5 col-xl-5">
      <div class="dashboard-btn dashboard-manage">
        <a (click)="goBack()"><button class="btn btn-primary btn-dashboard">Back</button></a>
      </div>
    </div>
    <!--    <div class="col-12 col-md-7 col-lg-5 col-xl-5">-->
    <!--      <div class="dashbarod-btn dashboard-manage">-->
    <!--        &lt;!&ndash; <div> <a href="#"><button class="btn btn-primary btn-deshboard">Export list</button></a></div> &ndash;&gt;-->
    <!--        <div class="filter-row filter-row1">-->
    <!--          <div class="form-label show">Sort by :</div>-->
    <!--          <div class="select-wrapper-sm">-->
    <!--            <select class="form-control border-0 input-sm">-->
    <!--              <option value="featured">Name</option>-->
    <!--              <option value="rating">Name</option>-->
  <!--            </select>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
</div>
<!-------end profile with button design--------->
<!-----------user table------------------>
<div class="row section1">
  <div class="col-12">
    <div class="table-responsive applicants-details overflow-x-visible">
      <table class="table table-bordered user-table">
        <thead>
          <tr>
            <!--            <th scope="col">Entities</th>-->
            <th scope="col">Entity Name</th>
            <th scope="col">Category</th>
            <th scope="col">User</th>
            <th scope="col">User ID</th>
            <th scope="col">Ratings</th>
            <th scope="col">Reviews</th>
            <th scope="col">Actions</th>
          </tr>
        </thead>
        <tbody>
          @for (param of parameters; track param; let i = $index) {
            <tr class="client">
              <!--            <td>{{ param.category.categoryName }}</td>-->
              <td>{{ param.entity.entityName }}</td>
              <td>{{ param.category.categoryName }}</td>
              <td>{{ param.user.fullName }}</td>
              <td>{{ param.user.id }}</td>
              <td>
                @if (param.value.length) {
                  <li style="color: orange">Hindu : {{param.value[0].score}}</li>
                }
                @if (param.value.length) {
                  <li style="color: blue">Christian : {{param.value[1].score}}</li>
                }
                @if (param.value.length) {
                  <li style="color: green">Muslim : {{param.value[2].score}}</li>
                }
              </td>
              <td>{{ param.message }}</td>
              <td class="action">
                <div class="dropdown">
                  <button type="button" class="btn header-item waves-effect" id="page-header-user-dropdown"
                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                    <i class="las la-angle-down"></i>
                  </button>
                  <div class="dropdown-menu dropdown-menu-right animate slideIn">
                    <a class="dropdown-item" [routerLink]="['/single-review/', param.id]"><i
                    class="las la-eye font-size-16 align-middle mr-1"></i>
                  View</a>
                  <a class="dropdown-item" (click)="remove(param.id, i)"><i
                  class="las la-trash font-size-16 align-middle mr-1"></i>
                Delete</a>
              </div>
            </div>
          </td>
        </tr>
      }
    </tbody>
  </table>
</div>
</div>
</div>
</div>
